import { render, staticRenderFns } from "./MenuEditLogins.vue?vue&type=template&id=497413b6&scoped=true"
import script from "./MenuEditLogins.vue?vue&type=script&lang=js"
export * from "./MenuEditLogins.vue?vue&type=script&lang=js"
import style0 from "./MenuEditLogins.vue?vue&type=style&index=0&id=497413b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497413b6",
  null
  
)

export default component.exports